const getSocial = state => state.social || {};

export const getSocialData = state => getSocial(state).data;
export const getLoginData = state => getSocial(state).login;
